import company from "./company"
import department from "./department"
import project from "./project"
import role from "./role"
import qualification from "./qualification";
import position from "./position";
import positionGrade from "./positionGrade";
import permission from './permission'

export default {

    namespaced: true,

    modules: {
        company,
        department,
        project,
        role,
        qualification,
        position,
        positionGrade,
        permission
    },

}